import { FC } from 'react';
import AlertDialog from 'components/AlertDialog';
import Typography from '@mui/material/Typography';
import { Disclosure } from 'further-ui/hooks';

type Props = {
  disclosure: Disclosure;
};

const UpdatedCommitmentErrorModal: FC<Props> = ({ disclosure }) => (
  <AlertDialog
    open={disclosure.isOpen}
    title="Please first adjust reconciled funds"
    content={
      <>
        <Typography>
          The total commitment cannot be less than the subscription’s reconciled{' '}
          <em>Funds received</em>. To adjust the total commitment, please first
          add the new funds received as a payment in the <em>Funds received</em>{' '}
          section (at the bottom of the page) and unreconcile the original
          payment transaction.
        </Typography>
      </>
    }
    onClose={disclosure.onClose}
    btnLabels={{
      confirm: false,
      cancel: 'OK',
    }}
  />
);

export default UpdatedCommitmentErrorModal;
